// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__30fN-","alert":"SettungsInbox_alert__3Qd7R"};